/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import noop from '@atlaskit/ds-lib/noop';
import { skeleton as skeletonColorFn } from '@atlaskit/theme/colors';
import { gridSize } from '@atlaskit/theme/constants';
import SkeletonShimmer from '../internal/components/skeleton-shimmer';
var skeletonStyles = css({
  padding: "0 ".concat(gridSize() * 2.5, "px"),
  '::after': {
    display: 'block',
    width: '30%',
    height: gridSize(),
    backgroundColor: "var(--ds-background-neutral, ".concat(skeletonColorFn(), ")"),
    borderRadius: 100,
    content: '""'
  }
});
var defaultWidthStyles = css({
  '::after': {
    width: '30%'
  }
});
var customWidthStyles = css({
  '::after': {
    width: 'var(--width)'
  }
});
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */

var SkeletonHeadingItem = function SkeletonHeadingItem(_ref) {
  var _ref$isShimmering = _ref.isShimmering,
      isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering,
      testId = _ref.testId,
      width = _ref.width,
      _ref$cssFn = _ref.cssFn,
      cssFn = _ref$cssFn === void 0 ? noop : _ref$cssFn;
  return jsx(SkeletonShimmer, {
    isShimmering: isShimmering
  }, function (_ref2) {
    var className = _ref2.className;
    return jsx("div", {
      className: className,
      style: {
        '--width': width
      },
      css: [skeletonStyles, width ? customWidthStyles : defaultWidthStyles, // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
      cssFn(undefined)],
      "data-ds--menu--skeleton-heading-item": true,
      "data-testid": testId
    });
  });
};

export default SkeletonHeadingItem;